import slice from "./appDetailsSlice";

export default slice.reducer;
